import axios from 'axios';
import { CreateResponseAiRequest } from '../types';

export const createResponseAiRequest = ({ input, model, assistantId, tools }: CreateResponseAiRequest) => {
  return axios.post('https://z6ccnwd8ne.execute-api.eu-west-1.amazonaws.com/prod', {
    input,
    model,
    assistantId,
    tools,
  });
};

export const speechToTextRequest = (audioFile: string) => {
  return axios.post('https://m2z4glo26g.execute-api.eu-west-1.amazonaws.com/prod', {
    file: audioFile,
  });
};

export const createVectorStoreRequest = (file: string, fileName: string) => {
  return axios.post('https://rjwjpbepeg.execute-api.eu-west-1.amazonaws.com/prod', {
    file,
    fileName,
  });
};

export const deleteVectorStoreRequest = (fileId: string, vectorStoreId: string) => {
  return axios.post(`https://wcrmiomrbe.execute-api.eu-west-1.amazonaws.com/prod`, {
    fileId,
    vectorStoreId,
  });
};
